import { reduce } from 'lodash';

import styles from './EditorTextArea.less';
import { ToolbarConfig } from './EditorTextArea.types';

const MARKUP_REPLACEMENTS = {
  '': "'",
  '': "'",
};

export const convertMarkup = (markup: string) =>
  reduce(
    MARKUP_REPLACEMENTS,
    (memo, to, from) => memo.replaceAll(from, to),
    markup,
  );

type GetDefaultEditorConfigType = (
  additionalToolbarProps?: ToolbarConfig,
) => ToolbarConfig;

export const GetDefaultEditorConfig: GetDefaultEditorConfigType = (
  additionalToolbarProps: ToolbarConfig,
) => ({
  options: ['inline', 'list', 'textAlign', 'link', 'history'],
  inline: {
    options: ['bold', 'italic', 'underline', 'strikethrough'],
  },
  list: {
    inDropdown: false,
    options: ['unordered', 'ordered', 'indent', 'outdent'],
  },
  textAlign: {
    inDropdown: false,
    options: ['left', 'center', 'right', 'justify'],
  },
  ...additionalToolbarProps,
  image: {
    popupClassName: styles.image,
    inputAccept: 'image/jpeg,image/jpg,image/png,image/svg',
    urlEnabled: true,
    uploadEnabled: false,
    alignmentEnabled: false,
  },
  link: {
    popupClassName: styles.link,
    defaultTargetOption: '_blank',
  },
});
